module.exports = __webpack_public_path__ + "static/media/Template_45.1f6642d2.png";